import { render, staticRenderFns } from "./comp_UserOrderDetail-PaymentInstructions-DebinTransfer.vue?vue&type=template&id=50faca3c&"
import script from "./comp_UserOrderDetail-PaymentInstructions-DebinTransfer.vue?vue&type=script&lang=js&"
export * from "./comp_UserOrderDetail-PaymentInstructions-DebinTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports